import { render, staticRenderFns } from "./EditViewTermReports.vue?vue&type=template&id=476ae5de&scoped=true"
import script from "./EditViewTermReports.vue?vue&type=script&lang=js"
export * from "./EditViewTermReports.vue?vue&type=script&lang=js"
import style0 from "./EditViewTermReports.vue?vue&type=style&index=0&id=476ae5de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476ae5de",
  null
  
)

export default component.exports